import React, { useState } from "react";
import PropTypes from "prop-types";
import classnames from "classnames";

export default function Anchor(props) {
  const [clicked, setClicked] = useState(false);
  const { label, url, ...restProps } = props;
  const anchorRef = React.useRef(null);

  const anchorClass = classnames("anchor", {
    "anchor--disabled": restProps.disabled,
    "anchor--clicked": clicked,
  });

  return (
    <a
      ref={anchorRef}
      tabIndex="0"
      onKeyUp={handleKeyUp}
      onClick={handleOnClick}
      className={anchorClass}
      href={url}
      value={label}
      rel="noopener noreferrer"
    >
      {label}
    </a>
  );

  function handleKeyUp(e) {
    if (e.keyCode === 32) {
      anchorRef.current.click();
    }
  }

  function handleOnClick(event) {
    event.preventDefault();
    setClicked(true);
    if (restProps.onClick) {
      restProps.onClick(event, redirect);
    }
  }

  function redirect() {
    return () => {
      // clear user data stored on browser
      Object.keys(sessionStorage)
        .filter((variable) => variable.match(/^(CUSTOM_VARIABLE_).*/g))
        .forEach((key) => sessionStorage.removeItem(key));
      window.location.href = url;
    };
  }
}

Anchor.propTypes = {
  label: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired,
  onClick: PropTypes.func,
};
